import React from 'react';
import JobApplicationForm from './JobApplicationForm';
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Job Application Form</h1>
      <div className='jobAppl'><JobApplicationForm /></div>
    </div>
  );
}

export default App;
